const Marionette = require('backbone.marionette');
const templates = require('../templates');
const FooterActivitiesView = require('./footer_activities.js');
const app = require('../app.js');

module.exports = Marionette.LayoutView.extend({
  template() {
    return templates.footer;
  },
  regions: {
    footer_activities: '.right_block'
  },
  onBeforeShow() {
    const self = this;
    const currentBookingsCollection = this.model.get('currentBookings');
    const nextBookingsCollection = this.model.get('nextBookings');

    this.listenTo(currentBookingsCollection, 'update', collection => {
      if (!collection.isEmpty()) {
        self.showChildView(
          'footer_activities',
          new FooterActivitiesView({
            collection: currentBookingsCollection
          })
        );
      } else {
        self.showChildView(
          'footer_activities',
          new FooterActivitiesView({
            collection: nextBookingsCollection
          })
        );
      }
    });

    if (!currentBookingsCollection.isEmpty()) {
      this.showChildView(
        'footer_activities',
        new FooterActivitiesView({
          collection: currentBookingsCollection
        })
      );
      app.vent.trigger('displayFooterActually');
    } else {
      this.showChildView(
        'footer_activities',
        new FooterActivitiesView({
          collection: nextBookingsCollection
        })
      );
      app.vent.trigger('displayFooterNext');
    }
  },
  events: {
    click: 'displayFooterPopup'
  },
  displayFooterPopup() {
    app.vent.trigger('openFooterPopup');
  },
  onRender() {
    const self = this;
    this.$el.swipe({
      swipe(event, direction) {
        if (direction === 'up') {
          self.displayFooterPopup();
        }
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/views/footer.js